function initShowMore() {
    document.querySelectorAll('[data-show-more-btn]').forEach(function (btn) {
        var grid = btn.previousElementSibling;
        btn.addEventListener('click', function () {
            var hidden = Array.from(grid.querySelectorAll('[hidden]'));
            hidden.forEach(function (el) { el.removeAttribute('hidden'); });
            btn.remove();
            if (hidden[0]) {
                hidden[0].setAttribute('tabindex', '-1');
                hidden[0].focus();
            }
        });
    });
}

initShowMore();
